import React from "react";

export const AchInstitutionDisplay = (props) => {
  const { achInstitution, invalid, isRetiredLakeTrustRoutingNumber } = props.achInstitutionState;

  return (
    <div className="ach-institution">
      <div className={invalid == false ? "" : "hide"}>
        <p data-e2e-id="achInstitution">{achInstitution}</p>
        {props.showIcons && <i className={!invalid ? "material-icons" : "hide"}>check_circle</i>}
      </div>
      <div className={invalid == true ? "error" : "hide"}>
        <p className={!isRetiredLakeTrustRoutingNumber ? "error-message" : "hide"}>
          Invalid Routing Number.
        </p>
        <p className={isRetiredLakeTrustRoutingNumber ? "error-message" : "hide"}>
          Routing Number is no longer valid. The current Lake Trust Routing Number is 272078268.
        </p>
        {props.showIcons && (
          <i className={invalid && !isRetiredLakeTrustRoutingNumber ? "material-icons" : "hide"}>
            error_outline
          </i>
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ach-institution-display/ach-institutiton-display.component.js